import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   cardToken:null,
   customer:null
};

const resourceTypes = {
   parcel: 1
};
const planTypes = {
   studio: {id: 'plan_1'},
   dayPass:{id: 'plan_2'},
   annual: {id: 'plan_3'},
};
const products = {
   parcel: {id:'product_1'}
};

// getters
const getters = {

};

// actions
const actions = {
   STRIPE_CARD_TOKEN_GET: (context, {stripeToken})=>{
      return new Promise((resolve, reject)=>{
         api.post('/api/stripe/cards',{
            stripeToken: stripeToken
         })
         .then((res)=>{
            // res.data.stripeCardId
            context.commit('STRIPE_CARD_TOKEN_SET', res.data.stripeCardId);
            resolve(res);
         })
         .catch((error,res)=>{
            if (error.response && error.response.data.error) context.commit('ERROR_MESSAGE_SET',{message:error.response.data.error});
            else context.commit('ERROR_MESSAGE_SET',{message:apiError.message('card token',error)});
            reject(error);
         });
      });
   },
   STRIPE_CHARGE: (context, {cardToken, product, resourceType, resourceId})=>{
      cardToken = cardToken || state.cardToken;
      return new Promise((resolve, reject)=>{
         api.post('/api/charges',{
            product:products[product],
            stripeCardId: cardToken,
            resourceType: resourceTypes[resourceType],
            resourceId: resourceId
         })
         .then((res)=>{
            resolve(res);
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('card charge',error)});
            reject(error);
         });
      });
   },
   STRIPE_CARD_REMOVE: (context, {cardId, cardToken})=>{
      return new Promise((resolve, reject)=>{
         api.delete('/api/stripe/cards/'+cardId,{
            stripeToken: cardToken
         })
         .then((res)=>{
            context.commit('STRIPE_CARD_REMOVE', {id:cardId});
            resolve(res);
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('card remove',error)});
            reject(error);
         });
      });
   },
   STRIPE_CARD_ADD: (context, {stripeToken})=>{
      return new Promise((resolve, reject)=>{
         api.post('/api/stripe/cards',{
            stripeToken: stripeToken
         })
         .then((res)=>{
            console.log('stripe card add:',res);
            //context.commit('STRIPE_CARD_ADD', {id:cardId});
            resolve(res);
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('card add',error)});
            reject(error);
         });
      });
   },
   STRIPE_CARD_CLEAR: (context)=>{
      context.commit('STRIPE_CARD_TOKEN_CLEAR');
   },
   STRIPE_SUBSCRIBE: (context, {plan, cardToken})=>{
      cardToken = cardToken || state.cardToken;
      return new Promise((resolve, reject)=>{
         api.post('/api/subscriptions',{
            plan: planTypes[plan],
            stripeCardId: cardToken
         })
         .then((res)=>{
            resolve(res);
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('subscription',error)});
            reject(error);
         });
      });
   },
};

// mutations
const mutations = {
   STRIPE_CARD_TOKEN_SET: (state, {cardToken})=>{
      state.cardToken = cardToken;
   },
   STRIPE_CARD_TOKEN_CLEAR: (state)=>{
      if (state.cardToken) state.cardToken = null;
   },
   STRIPE_CARD_REMOVE: (state, {id})=>{
      let ind;
      for (let i=0,len=state.customer.sources.data;i<len;i++){
         let card = state.customer.sources.data[i];
         if (card.id === id){
            ind = i;
            break;
         }
      }
      state.customer.sources.data.splice(ind,1);
   },
   STRIPE_CUSTOMER_SET: (state, {customer})=>{
      state.customer = customer;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/stripe.js